/**
 * @generated SignedSource<<c67e727ef3a1c9eaca21d30e99fe3146>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionSubscription_item$data = {
  readonly isSold: boolean | null;
  readonly isUnavailable: boolean | null;
  readonly relevantAuctionLot: {
    readonly endDate: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"useAuctionState_item">;
  readonly " $fragmentType": "PdpSharedAuctionSubscription_item";
};
export type PdpSharedAuctionSubscription_item$key = {
  readonly " $data"?: PdpSharedAuctionSubscription_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionSubscription_item">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "page",
    "value": "pdp"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSubscription_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUnavailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "AuctionLot",
      "kind": "LinkedField",
      "name": "relevantAuctionLot",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "endDate",
          "storageKey": null
        }
      ],
      "storageKey": "relevantAuctionLot(page:\"pdp\")"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "useAuctionState_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8ae0413d9e78b3d02936121d865fe683";

export default node;
